<template>
  <a-drawer
    :visible="visible"
    :title="title"
    width="60%"
    destroyOnClose
    @close="onClose"
  >
    <div>
      <From
        ref="formRef"
        layoutType="grid"
        :isErrorMessage="false"
        :optionList="formRows"
        :formRules="formRules"
        :defaultModel="defaultModel"
      >
      </From>
    </div>
    <div class="footer-but">
      <a-button style="margin-right: 8px" @click="onClose"> 取消 </a-button>
      <a-button class="first-but" type="primary" @click="handleOk">
        确定
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
//import {is_cloneDeep} from '@/utils/cloneDeep.js'
import {is_cloneDeep} from '@/utils/cloneDeep.js'
import { addMenu, updateMenu, getMunuDetail } from '@/api/back.js'
import { formRow, formRules, hasEnglishName, aticalIndex } from './modal.js'
import From from '@/views/Back/components/formTable/form.vue'
export default {
  props: {
    row: {
      type: Object,
      default: () => { }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: () => []
    }
  },
  components: { From },
  data () {
    return {
      title: '新增',
      formRows: [],
      formRules, // 表单校验规则配置
      defaultModel: {
        status: '1'
      } // 表单的默认值
    }
  },
  //模拟动态添加数据
  watch: {
    visible: {
      handler (n) {
        if (n) {
          this.formRows = is_cloneDeep(formRow)
          //上级组织列表数据
          this.formRows.forEach((item, i) => {
            if (item.prop === 'parentId') {
              this.$set(this.formRows[i], 'list', this.treeData)
            }
            if (item.prop === 'limitNum' && this.isEdit) {
              this.$set(this.formRows[i], 'disabled', true)
            }
            if (item.prop === 'code') {
              this.$set(item, 'disabled', false)
              this.$nextTick(() => {
                this.$refs.formRef.updateFormConfig('code', item)
              })
            }
          })
          if (this.row && !this.isEdit) {
            if (this.row.parentId === 0) {
              this.defaultModel = {
                parentId: 100
              }
            } else {
              this.defaultModel = {
                parentId: this.row.id
              }
            }
          }
          //当有isEdit代表不为新增
          if (this.isEdit) {
            //getData
            this.title = '配置'
            //拿到数据赋值
            this.getData()
          }
        }
      }
    }
  },
  methods: {
    async handleOk () {
      const v1 = this.$refs.formRef.validatedForm()
      const refD = this.$refs.formRef.formModel
      if (!v1) {
        return false
      }
      //this.$emit('ok')
      if (this.isEdit && hasEnglishName.includes(refD.code) && !refD.englishName) {
        this.$message.error('英文名称不能空')
        return
      }
      const res = this.isEdit
        ? await updateMenu({ ...refD, menuId: this.row.id })
        : await addMenu(refD)
      if (res.code === 200) {
        this.$message.success(res.msg)
        this.reset()
        this.$emit('ok')
        // if (!this.isEdit) {
        //   this.$bus.$emit('editMenu')
        // }
         this.$bus.$emit('editMenu')
      } else {
        this.$message.error(res.msg)
      }
    },
    onClose () {
      this.reset()
      this.$emit('ok')
    },
    reset () {
      this.title = '新增'
      this.defaultModel = {
        status: '1'
      }
    },
    async getData () {
      let {
        data: {
          parentId,
          menuName,
          leader,
          orderNum,
          phone,
          email,
          englishName,
          status,
          code,
          limitNum
        }
      } = await getMunuDetail(this.row.id)
      if (limitNum === null) {
        limitNum = ' '
      }

      if (code !== null) {
        this.formRows.forEach(res => {
          if (res.prop === 'code') {
            this.$set(res, 'disabled', true)
            this.$nextTick(() => {
              this.$refs.formRef.updateFormConfig('code', res)
            })
          }
        })
      }
      console.log(code);
      if (hasEnglishName.includes(code)) {
         this.$set(this.formRows[1], 'placeholder', menuName)
         this.$set(this.formRows[2], 'placeholder', englishName)
      } else {
        this.formRows.splice(2,1)
      }
      if(!aticalIndex.includes(code)) {
        this.formRows.splice(-3,1)
      }
      this.defaultModel = {
        parentId: parentId || '',
        menuName,
        leader,
        orderNum,
        phone,
        email,
        englishName,
        status,
        code,
        limitNum
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>